import { EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';

@Injectable()
export class RosterEventService {

    public search: EventEmitter<any> = new EventEmitter<any>();

    constructor() { }

    public onSearch(){
        this.search.emit(null);
    }
}
